
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";

import { PanoramaController } from "@/components/panorama.controller";

export class PanoNavigateById extends Action {

  /** the panorama to navigate to */
  public _id: number = 0;

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_NAVIGATE_BY_ID,
      type:  ActionType.PANO_NAVIGATE_BY_ID,
      label: 'Jumpt to Panorama by id',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** set the turn amount (degrees) */
  public to(id: number) {

    this._id = id;
  }

  /** fetch the turn amount (delta) */
  public id(): number {

    return this._id;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    if (this._id < 1) {

      if (this.args.length > 0) {

        this._id = Number(this.args[0]);
      }
    }

    this._controller.navigateTo(this._id);

    return true;
  }
}
